import { getHtml } from '../apis/templateHtml';
import '../css/layoutBulkDownload.scss';
import { endLoadingDisplay, startLoadingDisplay } from '../modules/uiManager/UiLoadingDisplay';
import { showPopupAlert } from '../modules/uiManager/UiPopup';
import { openFileDialog } from '../modules/uiManager/UiFileDialog';
import { initializeHeader } from './header';
import { downloadGcsFileToLocal, getGcsFileUploadedAt, uploadGcsFile } from '../apis/firebaseStorage';
import { fetchProgress, requestImport, requestCollect, requestCancel } from '../apis/layoutBulkDownloadApi';
/** ポーリング用のインターバルID */
let progressIntervalId = null;
/** 現在のソート列 */
let sortKey = 'createdAt';
let sortOrder = 'desc';
/** 最後に取得した出力状況 */
let latestProgressList = [];
/**
 * レイアウト一括取得を初期化する
 */
export const initializeLayoutBulkDownload = async () => {
    console.log('=== initializeLayoutBulkDownload 開始 ===');
    startLoadingDisplay();
    sortKey = 'createdAt';
    sortOrder = 'desc';
    latestProgressList = [];
    try {
        // HTML取得
        const layoutBulkDownloadContent = await getHtml("/layoutBulkDownload.html");
        const subContents = document.getElementById('subContents');
        if (layoutBulkDownloadContent && subContents) {
            subContents.innerHTML = layoutBulkDownloadContent;
            // ヘッダーを初期化
            initializeHeader("レイアウト一括取得", true);
            // イベントリスナーを設定
            setupEventListeners();
            // 初回の出力状況を取得・描画
            await fetchAndRenderProgress();
            // 10秒ごとのポーリングを開始
            scheduleProgressPolling();
            console.log('=== initializeLayoutBulkDownload 完了 ===');
        }
        endLoadingDisplay();
    }
    catch (error) {
        console.error('レイアウト一括取得の初期化でエラーが発生しました:', error);
        endLoadingDisplay();
    }
};
/**
 * イベントリスナーを設定
 */
function setupEventListeners() {
    // 出力ボタン
    const btnExportTemplate = document.getElementById('btnExportTemplate');
    if (btnExportTemplate) {
        btnExportTemplate.addEventListener('click', handleExportTemplate);
    }
    // 更新ボタン
    const statusRefreshButton = document.getElementById('statusRefreshButton');
    if (statusRefreshButton) {
        statusRefreshButton.addEventListener('click', handleRefreshStatus);
    }
    // Excel取込ボタン
    const btnImportExcel = document.getElementById('btnImportExcel');
    if (btnImportExcel) {
        btnImportExcel.addEventListener('click', () => handleImportExcel());
    }
    // ソートアイコン
    const btnSortCreatedAt = document.getElementById('btnSortCreatedAt');
    if (btnSortCreatedAt) {
        btnSortCreatedAt.addEventListener('click', () => handleSort('createdAt'));
    }
    const btnSortStatus = document.getElementById('btnSortStatus');
    if (btnSortStatus) {
        btnSortStatus.addEventListener('click', () => handleSort('status'));
    }
    // 初期ソート状態をアイコンに反映
    updateSortIcons();
}
/** ソートアイコンの画像パス */
const SORT_ICON_DEFAULT = '../images/topmenu/updown-arrows.svg';
const SORT_ICON_ASC = '../images/topmenu/arrow-up.svg';
const SORT_ICON_DESC = '../images/topmenu/arrow-down.svg';
/**
 * ソート状態に応じてソートアイコンを切り替える
 * 現在のソート列は昇順=↑ / 降順=↓、それ以外の列は上下矢印を表示する
 */
function updateSortIcons() {
    const targets = [
        { id: 'btnSortCreatedAt', key: 'createdAt' },
        { id: 'btnSortStatus', key: 'status' },
    ];
    targets.forEach(({ id, key }) => {
        const icon = document.getElementById(id);
        if (!icon)
            return;
        if (sortKey !== key) {
            icon.src = SORT_ICON_DEFAULT;
            icon.alt = 'ソート';
        }
        else if (sortOrder === 'asc') {
            icon.src = SORT_ICON_ASC;
            icon.alt = '昇順';
        }
        else {
            icon.src = SORT_ICON_DESC;
            icon.alt = '降順';
        }
    });
}
/**
 * ソートアイコン押下時の処理
 */
function handleSort(key) {
    if (sortKey === key) {
        sortOrder = sortOrder === 'desc' ? 'asc' : 'desc';
    }
    else {
        sortKey = key;
        sortOrder = 'asc';
    }
    updateSortIcons();
    renderProgressTableDom(latestProgressList);
}
/** ステータスの並び順 */
const STATUS_SORT_ORDER = [
    'validating',
    'imported',
    'downloading',
    'compressing',
    'completed',
    'partiallyCompleted',
    'error',
    'cancel'
];
/**
 * 現在のソート列・ソート順に応じて並び替えた配列を返す
 * ステータス列は STATUS_SORT_ORDER の順で比較し、同値の場合は取込日時の降順とする
 */
function sortProgressList(dataList) {
    const direction = sortOrder === 'asc' ? 1 : -1;
    const compareCreatedAt = (a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime();
    // 定義にないステータスは最後尾（昇順の場合）に並べる
    const statusRank = (item) => {
        const index = STATUS_SORT_ORDER.indexOf(item.status);
        return index === -1 ? STATUS_SORT_ORDER.length : index;
    };
    return [...dataList].sort((a, b) => {
        if (sortKey === 'createdAt') {
            return compareCreatedAt(a, b) * direction;
        }
        const result = statusRank(a) - statusRank(b);
        return result !== 0 ? result * direction : -compareCreatedAt(a, b);
    });
}
/**
 * 10秒間隔のポーリングタイマーを設定する。
 */
function scheduleProgressPolling() {
    // 既存のポーリングをクリア
    stopProgressPolling();
    progressIntervalId = setInterval(() => {
        fetchAndRenderProgress();
    }, 10000);
}
/**
 * ポーリングを停止する
 */
export function stopProgressPolling() {
    if (progressIntervalId !== null) {
        clearInterval(progressIntervalId);
        progressIntervalId = null;
    }
}
/**
 * 出力状況を取得してテーブルを描画する
 * @param throwOnError true の場合、取得失敗時に例外を呼び出し元へ再スローする（ポップアップ表示用）
 */
async function fetchAndRenderProgress(throwOnError = false) {
    try {
        latestProgressList = (await fetchProgress()) || [];
        renderProgressTableDom(latestProgressList);
    }
    catch (error) {
        console.error('出力状況の取得に失敗しました:', error);
        if (throwOnError) {
            throw error;
        }
    }
}
/** テンプレートファイル名（サーバー側の固定名と一致） */
const TEMPLATE_FILENAME = 'レイアウト一括取得テンプレート.xlsx';
/**
 * 出力処理
 */
async function handleExportTemplate() {
    try {
        console.log('出力処理を開始します');
        startLoadingDisplay();
        await downloadGcsFileToLocal(`template/${TEMPLATE_FILENAME}`, TEMPLATE_FILENAME);
    }
    catch (error) {
        console.error('出力処理でエラーが発生しました:', error);
        showPopupAlert({
            text: '出力中にエラーが発生しました。\nしばらく時間をおいて再度お試しください。',
            showBackdrop: true
        });
    }
    finally {
        endLoadingDisplay();
    }
}
/**
 * Excel取込処理
 */
async function handleImportExcel() {
    // ファイル選択ダイアログを表示
    const file = await openFileDialog('.xlsx');
    if (!file)
        return;
    // 拡張子チェック
    const fileName = file.name.toLowerCase();
    const hasValidExtension = fileName.endsWith('.xlsx');
    if (!hasValidExtension) {
        showPopupAlert({
            text: 'ファイル形式がExcel(.xlsx)ではありません。',
            showBackdrop: true
        });
        return;
    }
    try {
        startLoadingDisplay();
        const fileUuid = crypto.randomUUID();
        const filePath = `${fileUuid}/${TEMPLATE_FILENAME}`;
        await uploadGcsFile(filePath, file);
        const response = await requestImport(fileUuid);
        if (response.data?.statusCode === 200) {
            showPopupAlert({
                text: response.data?.message,
                showBackdrop: true
            });
        }
        else {
            showPopupAlert({
                text: response.data?.message || 'Excel取込に失敗しました。\nしばらく時間をおいて再度お試しください。',
                showBackdrop: true
            });
        }
    }
    catch (error) {
        console.error('Excel取込でエラーが発生しました:', error);
        showPopupAlert({
            text: 'Excel取込中にエラーが発生しました。\nしばらく時間をおいて再度お試しください。',
            showBackdrop: true
        });
    }
    finally {
        await fetchAndRenderProgress();
        endLoadingDisplay();
    }
}
/**
 * 出力状況のエラー内容をポップアップ表示する（結果ログがない場合）
 * トレースNoがある場合のみ、トレースNoとコピーアイコンを表示する
 */
function showProgressErrorPopup(item) {
    showPopupAlert({
        text: item.errorMessage || '',
        showBackdrop: true,
        traceId: item.traceId || undefined
    });
}
/**
 * 結果ログをGCSからダウンロードする
 * @param resultLogFilePath 出力状況の resultLogFilePath（結果ログのGCS上のパス）
 */
async function handleResultLogDownload(resultLogFilePath) {
    try {
        startLoadingDisplay();
        const uploadedAt = await getGcsFileUploadedAt(resultLogFilePath);
        await downloadGcsFileToLocal(resultLogFilePath, `${formatDateTimeForFileName(uploadedAt)}_レイアウト一括取得結果ログ.xlsx`);
    }
    catch (error) {
        console.error('結果ログのダウンロードでエラーが発生しました:', error);
        showPopupAlert({
            text: '結果ログのダウンロード中にエラーが発生しました。\nしばらく時間をおいて再度お試しください。',
            showBackdrop: true
        });
    }
    finally {
        endLoadingDisplay();
    }
}
/**
 * 取込ファイルをGCSからダウンロードする
 * @param taskId 出力状況の taskId（GCS上のディレクトリ名）
 */
async function handleUploadFileDownload(taskId) {
    try {
        startLoadingDisplay();
        const filePath = `${taskId}/${TEMPLATE_FILENAME}`;
        const uploadedAt = await getGcsFileUploadedAt(filePath);
        await downloadGcsFileToLocal(filePath, `${formatDateTimeForFileName(uploadedAt)}_レイアウト一括取得取込ファイル.xlsx`);
    }
    catch (error) {
        console.error('取込ファイルのダウンロードでエラーが発生しました:', error);
        showPopupAlert({
            text: '取込ファイルのダウンロード中にエラーが発生しました。\nしばらく時間をおいて再度お試しください。',
            showBackdrop: true
        });
    }
    finally {
        endLoadingDisplay();
    }
}
/**
 * 実行ボタン押下時の処理
 */
async function handleExecuteCollect(fileUuid) {
    try {
        startLoadingDisplay();
        const response = await requestCollect(fileUuid);
        if (response.data?.statusCode === 200) {
            showPopupAlert({
                text: response.data?.message || '実行処理を開始しました。',
                showBackdrop: true
            });
        }
        else {
            showPopupAlert({
                text: response.data?.message || '実行処理の開始に失敗しました。',
                showBackdrop: true
            });
        }
    }
    catch (error) {
        console.error('実行処理でエラーが発生しました:', error);
        showPopupAlert({
            text: '実行中にエラーが発生しました。\nしばらく時間をおいて再度お試しください。',
            showBackdrop: true
        });
    }
    finally {
        await fetchAndRenderProgress();
        endLoadingDisplay();
    }
}
/**
 * 中止ボタン押下時の処理
 */
async function handleCancelImport(fileUuid) {
    try {
        startLoadingDisplay();
        const response = await requestCancel(fileUuid);
        if (response.data?.statusCode === 200) {
            showPopupAlert({
                text: response.data?.message || '中止しました。',
                showBackdrop: true
            });
        }
        else {
            showPopupAlert({
                text: response.data?.message || '中止処理に失敗しました。',
                showBackdrop: true
            });
        }
    }
    catch (error) {
        console.error('中止処理でエラーが発生しました:', error);
        showPopupAlert({
            text: '中止処理中にエラーが発生しました。\nしばらく時間をおいて再度お試しください。',
            showBackdrop: true
        });
    }
    finally {
        await fetchAndRenderProgress();
        endLoadingDisplay();
    }
}
/**
 * zipファイルをGCSからダウンロードする
 * @param zipFilePath 出力状況の zipFilePath（進捗テーブルの zip_file_path。GCS上のzipのパス）
 * @param uploadedAt アップロード日時（出力状況の updatedAt。ファイル名に使用）
 */
async function handleZipDownload(zipFilePath, uploadedAt) {
    try {
        startLoadingDisplay();
        await downloadGcsFileToLocal(zipFilePath, `${formatDateTimeForFileName(uploadedAt)}_layout.zip`);
    }
    catch (error) {
        console.error('zipダウンロードでエラーが発生しました:', error);
        showPopupAlert({
            text: 'ダウンロード中にエラーが発生しました。\nしばらく時間をおいて再度お試しください。',
            showBackdrop: true
        });
    }
    finally {
        endLoadingDisplay();
    }
}
/**
 * 更新ボタン押下時の処理
 */
async function handleRefreshStatus() {
    // 更新中にポーリングが発火して二重にfetchされないよう、先に停止する
    stopProgressPolling();
    try {
        startLoadingDisplay();
        await fetchAndRenderProgress(true);
    }
    catch (error) {
        console.error('出力状況の更新に失敗しました:', error);
        showPopupAlert({
            text: '出力状況の取得に失敗しました。\nしばらく時間をおいて再度お試しください。',
            showBackdrop: true
        });
    }
    finally {
        endLoadingDisplay();
        // 更新完了時点から10秒間隔のポーリングに戻す
        scheduleProgressPolling();
    }
}
/**
 * セルを生成する
 */
function createTextCell(text) {
    const td = document.createElement('td');
    td.textContent = text;
    return td;
}
/**
 * ボタンを生成する
 * @param options.enabled false の場合は disabled にし、クリックハンドラを登録しない
 */
function createActionButton(options) {
    const btn = document.createElement('button');
    btn.id = options.id;
    btn.className = options.className;
    if (options.text !== undefined) {
        btn.textContent = options.text;
    }
    if (options.iconSrc) {
        const img = document.createElement('img');
        img.src = options.iconSrc;
        img.alt = 'ダウンロード';
        btn.appendChild(img);
    }
    if (options.enabled) {
        if (options.onClick) {
            btn.addEventListener('click', options.onClick);
        }
    }
    else {
        btn.disabled = true;
    }
    return btn;
}
/**
 * 出力状況テーブルの1行を DOM API で生成する
 */
function createProgressRow(item, index) {
    const status = item.status;
    const count = item.progressTotal != null ? `${item.progressTotal.toLocaleString()}件` : '';
    // ダウンロード中のみ、メッセージに続けて「処理済み件数/総件数」を表示する
    const downloadingMessage = status === 'downloading'
        ? `${item.progressMessage || ''} ${item.progressCurrent ?? 0}件/${item.progressTotal ?? 0}件中`
        : (item.progressMessage || '');
    // ステータスに応じたボタン活性制御
    const uploadFileEnabled = status !== 'validating';
    const operationEnabled = status === 'imported';
    // 結果ログ・ZIPはステータスではなく、サーバーが進捗テーブルへ保存したパスの有無で活性化する
    const resultLogFilePath = item.resultLogFilePath;
    // 結果ログがない場合でも、エラー内容があればボタン押下でポップアップ表示する
    const errorMessage = item.errorMessage;
    const resultLogEnabled = !!resultLogFilePath || !!errorMessage;
    const zipFilePath = item.zipFilePath;
    const resultFileEnabled = !!zipFilePath;
    const downloadIcon = '../images/topmenu/download.svg';
    const tr = document.createElement('tr');
    tr.appendChild(createTextCell(String(index + 1)));
    tr.appendChild(createTextCell(formatDateTime(item.createdAt)));
    tr.appendChild(createTextCell(item.createdBy || ''));
    tr.appendChild(createTextCell(count));
    tr.appendChild(createTextCell(downloadingMessage));
    // 取込ファイルダウンロード
    const uploadTd = document.createElement('td');
    uploadTd.appendChild(createActionButton({
        id: `btnUploadDownload_${item.taskId}`,
        className: 'download-icon-button',
        iconSrc: downloadIcon,
        enabled: uploadFileEnabled && !!item.taskId,
        onClick: () => handleUploadFileDownload(item.taskId),
    }));
    tr.appendChild(uploadTd);
    // 取込結果ログダウンロード
    const resultLogTd = document.createElement('td');
    resultLogTd.appendChild(createActionButton({
        id: `btnResultLog_${item.taskId}`,
        className: 'download-icon-button',
        iconSrc: downloadIcon,
        enabled: resultLogEnabled && !!item.taskId,
        onClick: () => resultLogFilePath
            ? handleResultLogDownload(resultLogFilePath)
            : showProgressErrorPopup(item),
    }));
    tr.appendChild(resultLogTd);
    // 操作（実行・中止）
    const operationTd = document.createElement('td');
    operationTd.appendChild(createActionButton({
        id: `btnExecute_${item.taskId}`,
        className: 'import-button',
        text: '実行',
        enabled: operationEnabled,
        onClick: () => handleExecuteCollect(item.taskId),
    }));
    operationTd.appendChild(createActionButton({
        id: `btnCancel_${item.taskId}`,
        className: 'cancel-button',
        text: '中止',
        enabled: operationEnabled,
        onClick: () => handleCancelImport(item.taskId),
    }));
    tr.appendChild(operationTd);
    // レイアウトファイルダウンロード
    const resultDownloadTd = document.createElement('td');
    resultDownloadTd.appendChild(createActionButton({
        id: `btnResultDownload_${item.taskId}`,
        className: 'download-button',
        text: 'ダウンロード',
        enabled: resultFileEnabled && !!item.taskId,
        onClick: () => handleZipDownload(zipFilePath, item.updatedAt),
    }));
    tr.appendChild(resultDownloadTd);
    return tr;
}
/**
 * 出力状況テーブルを描画する（DOM API版）
 * innerHTML を使わず textContent で値を設定するため、XSS エスケープ不要。
 * イベントリスナーは各ボタン生成時に直接登録する。
 */
function renderProgressTableDom(dataList) {
    const tbody = document.getElementById('tblOutputStatus');
    if (!tbody)
        return;
    const fragment = document.createDocumentFragment();
    sortProgressList(dataList).forEach((item, index) => {
        fragment.appendChild(createProgressRow(item, index));
    });
    tbody.replaceChildren(fragment);
}
/**
 * ISO8601日時を表示用フォーマットに変換する
 */
function formatDateTime(isoString) {
    if (!isoString)
        return '';
    const d = new Date(isoString);
    if (isNaN(d.getTime()))
        return '';
    return `${d.getFullYear()}/${d.getMonth() + 1}/${d.getDate()} ${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}:${d.getSeconds().toString().padStart(2, '0')}`;
}
/**
 * ISO8601日時をファイル名用の yyyymmddhhmmss 形式に変換する
 */
function formatDateTimeForFileName(isoString) {
    if (!isoString)
        return '';
    const d = new Date(isoString);
    if (isNaN(d.getTime()))
        return '';
    const pad = (n) => n.toString().padStart(2, '0');
    return `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}${pad(d.getHours())}${pad(d.getMinutes())}${pad(d.getSeconds())}`;
}
